export enum NotificationType {
    INFO,
    ERROR,
}
